// AuthGuard.tsx
// Uses Clerk for authentication state.
// - Loading: spinner/title screen
// - Signed out: full LandingPage (not a bare sign-in form)
// - Signed in: renders the app

import React from 'react';
import { useUser } from '@clerk/clerk-react';
import type { Theme } from '../types';
import LandingPage from './LandingPage';
import ThemeToggle from './ThemeToggle';
import loadingStyles from '../styles/LoadingState.module.css';

interface AuthGuardProps {
  children: React.ReactNode;
  theme: Theme;
  onToggleTheme: () => void;
}

export default function AuthGuard({ children, theme, onToggleTheme }: AuthGuardProps) {
  const { isLoaded, isSignedIn } = useUser();

  if (!isLoaded) {
    return (
      <div className={loadingStyles.page}>
        <h1 className={loadingStyles.title}>Desk Reject</h1>
        <p className={loadingStyles.filename}>Loading...</p>
        <ThemeToggle theme={theme} onToggle={onToggleTheme} />
      </div>
    );
  }

  if (!isSignedIn) {
    return <LandingPage theme={theme} onToggleTheme={onToggleTheme} />;
  }

  return <>{children}</>;
}
